// Tray size definitions
export const TRAY_SIZES = {
 'HR Small': { width: 7.75, depth: 14, height: 0.75 },
 'HR Medium': { width: 7.5, depth: 18, height: 0.75 },
 'HR Large': { width: 9, depth: 20.5, height: 0.75 },
 'HR XL': { width: 10.9, depth: 29.5, height: 0.75 },
 'SF Standard': { width: 8, depth: 20, height: 1 },
 'SF Mega': { width: 10.5, depth: 27.5, height: 1 },
 '1/4 Sheet': { width: 9.5, depth: 13, height: 1 },
 '1/2 Sheet': { width: 13, depth: 18, height: 1 },
 'Full Sheet': { width: 18, depth: 26, height: 1 }
};

// Field descriptions for tooltips
export const fieldDescriptions = {
 units_per_batch: "Total number of sellable units (bags, jars, packages) you can produce in one freeze-dry cycle",
 selling_price: "The price you will charge per unit (before taxes)",
 ingredient_cost: "Total cost of raw ingredients for one batch",
 packaging_cost: "Total cost of all packaging materials (bags, labels, seals, etc.) for one batch",
 labor_hours: "Total labor hours required to prep, load, unload, and package one batch",
 labor_rate: "Hourly rate you pay for labor (or value your own time)",
 electricity_cost: "Total electricity cost for running the freeze dryer for one complete cycle",
 consumables_cost: "Cost of items consumed per batch: mylar bags, oxygen absorbers, labels, tape, etc.",
 waste_loss: "Cost of product lost to waste, defects, or sampling per batch"
};
